<template>
  <v-card>
    <v-card-title>
      <v-layout row>
        <span class="headline mb-0">INV</span>
        <span class="ml-2">
          <v-checkbox
            :label="this.poNo + ' Only'"
            style="margin-top: 0px; height: 20px"
            v-model="only"
          />
        </span>
        <v-spacer />
        <v-btn @click="changePrice" v-if="newUnitPrice" v-permit.SHARP_PCD_UNIT_CANCEL>単価变更</v-btn>
      </v-layout>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="packages"
      :loading="loading"
      class="inline-edit"
      hide-actions
      item-key="id"
    >
      <template slot="items" slot-scope="props">
        <td width="150">{{ props.item.invoiceNo }}</td>
        <td :style="diffStyle('poNo', props.item)" width="150">{{ props.item.poNo }}</td>
        <td width="200">{{ props.item.productCode }}:{{ props.item.productName }}</td>
        <td width="200">{{ props.item.skuCode }}</td>
        <td width="100">{{ props.item.paid === 1 ? '有償' : '無償' }}</td>
        <td width="100">{{ props.item.cartonStartNo }}</td>
        <td width="100">{{props.item.cartonEndNo}}</td>
        <td width="100">{{props.item.perCartonQty}}</td>
        <td :style="diffStyle('qty', props.item)" width="100">{{props.item.totalQty}}</td>
        <td width="100">{{ props.item.currencyCode }}</td>
        <td :style="diffStyle('unitPrice', props.item)" width="100">{{ props.item.unitPrice }}</td>
        <td width="100">{{ props.item.invStatus }}</td>
        <td width="100">
          <v-btn
            @click="changeInv(props.item.invId)"
            v-if="props.item.invStatus !== 'CANCEL' && props.item.idx === 0 && props.item.invStatus !== 'HISTORY'"
          >变更</v-btn>
          <v-btn
            @click="cancelInv(props.item.invId)"
            v-if="props.item.invStatus !== 'CANCEL' && props.item.idx === 0 && props.item.invStatus !== 'HISTORY'"
          >I/V取消</v-btn>
        </td>
      </template>
    </v-data-table>
    <change-inv-dialog
      :conflictId="conflictId"
      :normalId="normalId"
      @submit="updateInv"
      ref="invDialog"
    ></change-inv-dialog>
  </v-card>
</template>
<script>
import ChangeInvDialog from './ChangeInvDialog'
export default {
  components: { ChangeInvDialog },
  props: ['conflictId', 'normalId'],
  data() {
    return {
      form: {},
      status: { NORMAL: '', CONFLICT: 'PO变更', CANCEL: 'PO取消' },
      headers: [
        { text: 'INV NO', value: 'invoiceNo', sortable: false },
        { text: 'P/O NO', value: 'poNo', sortable: false },
        { text: '品種', value: 'productCode', sortable: false },
        { text: '品番', value: 'skuCode', sortable: false },
        { text: '有償/無償', value: 'paid', sortable: false },
        { text: 'Carton Start No', value: 'cartonStartNo', sortable: false },
        { text: 'End No', value: 'cartonEndNo', sortable: false },
        { text: '入り数', value: 'perCartonQty', sortable: false },
        { text: '数量', value: 'totalQty', sortable: false },
        { text: '外貨', value: 'currencyCode', sortable: false },
        { text: '単価', value: 'unitPrice', sortable: false },
        { text: '状态', value: 'status', sortable: false },
        { text: '', value: '', sortable: false }
      ],
      results: [],
      loading: false,
      conflictType: 'UNKNOWN',
      conflictFields: [],
      newUnitPrice: null,
      only: true,
      errors: {
        INVALID_STATUS: 'D/O取消してください。',
        INVALID_SA_STATUS: 'S/A取消してください。',
        PACKAGE_QTY_OVER: 'POの発注数量を超えてしまう、ご確認ください。',
        INVALID_INV_STATUS: 'I/V取消してください'
      }
    }
  },
  methods: {
    changePrice() {
      this.results.forEach(inv => {
        inv.op = 'CHANGE'
        inv.packages
          .filter(pkg => pkg.poId === this.normalId)
          .forEach(pkg => {
            pkg.unitPrice = this.newUnitPrice
          })
      })
      this.results = [...this.results]
      this.$message('', '単価変更が完了でした。')
    },
    diffStyle(prop, item) {
      if (this.poNo === item.poNo && this.conflictFields.indexOf(prop) !== -1)
        return 'color: red; font-weight: bold; font-size: 16px'
      return ''
    },
    conflict(type, fields, newUnitPrice) {
      this.conflictType = type || 'UNKNOWN'
      this.conflictFields = fields || []
      this.newUnitPrice = newUnitPrice
    },
    changeInv(invId) {
      this.$refs.invDialog.popup(this.results.find(inv => inv.id === invId))
    },
    cancelInv(invId) {
      this.$confirm({
        content: '該当INVから該当POを削除してよろしいでしょうか？'
      }).then(() => {
        this.$http
          .post(`/commercial-invoices/${invId}/cancel-invoice`)
          .then(() => {
            this.$message('', 'Cancel success')
            this.load()
          })
          .catch(res => {
            this.$showError(res)
          })
      })
    },
    updateInv(inv) {
      // this.results.find(inv => inv.id === invId).op = 'CHANGE'
      // this.results = [...this.results]
      this.$http
        .post(`/commercial-invoices/update-invoice`, inv)
        .then(() => {
          this.$message('', 'inv update success')
        })
        .catch(res => {
          this.$showError(res)
        })
    },
    allPackageRemoved(inv) {
      return (
        inv.packages.length ===
        inv.packages.filter(pkg => pkg.removed === true).length
      )
    },
    save() {
      this.$confirm({ content: '变更してよろしいでしょうか?' }).then(() => {
        this.savePo()
      })
    },
    showError(res) {
      if (this.errors[res.response.data.message]) {
        this.$message(
          this.$t('app.messages.errors.title'),
          this.errors[res.response.data.message]
        )
      } else {
        this.$message(this.$t('app.messages.errors.title'), 'System Error.')
      }
    },
    savePo() {
      if (
        this.newUnitPrice &&
        this.packages
          .filter(p => p.poNo === this.poNo)
          .filter(pkg => pkg.unitPrice === this.newUnitPrice).length !=
          this.packages.filter(p => p.poNo === this.poNo).length
      ) {
        this.$message('', '単価を変更してください。')
      } else {
        this.$http
          .post('/commercial-invoices/merge-po', {
            conflictPoId: this.conflictId,
            normalPoId: this.normalId,
            cancelInvoices: this.results.filter(inv => inv.op === 'CANCEL'),
            updateInvoices: this.results.filter(inv => inv.op === 'CHANGE')
          })
          .then(() => {
            this.$message('', '該当POの变更が完了でした。')
            this.load()
          })
          .catch(res => this.showError(res))
      }
    },
    cancel() {
      this.$confirm({ content: '該当POを取消して宜しいでしょうか?' }).then(
        () => {
          this.cancelPo()
        }
      )
    },
    cancelPo() {
      this.$http
        .post('/commercial-invoices/cancel-po', {
          conflictPoId: this.conflictId,
          normalPoId: this.normalId,
          cancelInvoices: this.results.filter(inv => inv.op === 'CANCEL'),
          updateInvoices: this.results.filter(inv => inv.op === 'CHANGE')
        })
        .then(() => {
          this.$message('', '該当POの取消が完了でした。')
          this.load()
        })
        .catch(res => this.showError(res))
    },
    load() {
      this.loading = true
      this.$http
        .get(`/commercial-invoices/conflict?id=${this.normalId}`)
        .then(res => {
          this.results = res.data
          this.results.forEach(inv => {
            inv.op = 'CHANGE'
            inv.packages.forEach(pkg => (pkg.removed = false))
          })
          this.loading = false
        })
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    poNo() {
      return this.$route.query.poNo
    },
    packages() {
      var arr = []
      this.results.forEach(
        inv =>
          (arr = arr.concat(
            inv.packages.map(pkg => ({
              ...pkg,
              invId: inv.id,
              invoiceNo: pkg.invoiceNo || '',
              poNo: pkg.poNo || '',
              removed: pkg.removed || false,
              op: inv.op,
              invStatus: inv.status
            }))
          ))
      )
      arr.sort((a, b) =>
        (b.invoiceNo + b.poNo).localeCompare(a.invoiceNo + a.poNo)
      )
      if (this.only) {
        arr = arr.filter(pkg => this.poNo === pkg.poNo)
      }

      var obj = []
      return arr.map(pkg => {
        if (!obj[pkg.invoiceNo]) obj[pkg.invoiceNo] = 0
        return {
          ...pkg,
          idx: obj[pkg.invoiceNo]++
        }
      })

      // return arr arr.filter(pkg => pkg.removed === false)
    }
  }
}
</script>

